import React, { useState } from 'react';
import useTotalRevenueByStation from '../hooks/useTotalRevenueByStation';
import useTotalChargingSessionsByStation from '../hooks/useTotalChargingSessionsByStation';
import useTotalEnergyByStation from '../hooks/useTotalEnergyByStation';
import useTotalChargingSecondsByStation from '../hooks/useTotalChargingSecondsByStation';
import useTotalDistinctVehiclesByStation from '../hooks/useTotalDistinctVehiclesByStation';
import { formatINRNumber } from "../utils/formatINR";

const formatSecondsToHMS = (seconds) => {
  if (isNaN(seconds)) return '0hr:00min';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${hours}hr : ${paddedMinutes}min`;
};

const StationTiles = ({ tiles = [], onTileClick, range }) => {
  // const [selectedTile, setSelectedTile] = useState('Unique vehicles');
    const [selectedTile, setSelectedTile] = useState('Total revenue (₹)');
  

  // Hooks now accept range instead of daysCount
  const { totalEnergy, isLoading, error } = useTotalEnergyByStation(range);
  const { totalSessions, isLoading: isLoadingSessions } = useTotalChargingSessionsByStation(range);
  const { totalVehicles, isLoadingUniqueVehicles } = useTotalDistinctVehiclesByStation(range);
  const { totalChargingTime, isLoading: isLoadingChargingTime } = useTotalChargingSecondsByStation(range);
  const { totalRevenue, isLoading: isLoadingRevenue } = useTotalRevenueByStation(range);

  console.log("Range in StationTiles:", range);

  const handleTileClick = (title) => {
    setSelectedTile(title);
    if (onTileClick) onTileClick(title);
  };

  const defaultTiles = [
    { title: 'Total revenue (₹)', value: isLoadingRevenue ? 'Loading...' : formatINRNumber(totalRevenue) },
    { title: 'Total Energy (kW)', value: isLoading ? 'Loading...' : totalEnergy },
    { title: 'Total sessions', value: isLoadingSessions ? 'Loading...' : totalSessions },
    { title: 'Total hours', value: isLoadingChargingTime ? 'Loading...' : formatSecondsToHMS(totalChargingTime) },
    { title: 'Unique vehicles', value: isLoadingUniqueVehicles ? 'Loading...' : totalVehicles },
  ];

  const allTiles = tiles.length > 0 ? tiles : defaultTiles;

  console.log("All Tiles:", allTiles);

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {allTiles.map((tile, index) => {
          const isSelected = selectedTile === tile.title;

          return (
            <div
              key={tile.title}
              onClick={() => handleTileClick(tile.title)}
              className={`
                flex flex-col items-center justify-center p-4 rounded-2xl border transition-transform duration-300 cursor-pointer
                ${isSelected
                  ? 'bg-gradient-to-br from-gray-100 to-gray-200 shadow-lg transform scale-105 border-transparent'
                  : 'bg-white border-gray-200 hover:shadow-md hover:scale-102'}
              `}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <p className="text-lg font-semibold text-gray-800 text-center mb-1">
                {tile.value}
              </p>
              <h6 className="text-sm font-normal text-gray-600 text-center mb-2">
                {tile.title}
              </h6>
              {tile.change && (
                <p className="text-sm font-medium text-green-600 text-center">
                  {tile.change}
                </p>
              )}
              {isSelected && (
                <div className="mt-2 w-10 h-1 rounded-full bg-gray-800" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StationTiles;
